<template>
	<div class="chat-container w-100 position-relative">
    <div id="restaurant"></div>
    <!-- GENERAL -->
    <div v-if="is_load.general" class="w-100 py-4 text-center" style="min-height: 100vh;">
      <loader />
    </div>
    <template v-else>
    	<!-- NAVBAR -->
	    <div class="position-relative">
	      <div class="row no-gutters justify-content-center">
	        <div class="fixed-top d-block nav-bottom">
	          <div class="custom-container-fluid px-0">
	            <div class="row justify-content-center no-gutters">
	              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	                <div class="bg-white box-shadow-nav">
	                  <div class="w-100">
	                    <div class="container-fluid">
	                      <div
	                        class="row px-2 bg-green rounded-bottom-search" :class="{'bg-white py-1 delay':data.scrollPosition > 230}"
	                        style="padding-bottom: 30px;">
	                        <div class="col-10" style="padding-top: 10px;padding-left: 0">
	                          <div
	                            class="div-wrappera text-truncate mx-auto d-inline-block m-width-100"
	                          >
	                            <div class="text-center" style="width: max-content">
	                              <p
	                                class="body-1 mb-0 ml-3"
	                                :class="{'text-semi-dark delay text-16':data.scrollPosition > 230}"
	                                style="margin-top: 7px;color: #fff;font-size: 20px;"
	                              >{{ data.general.name }}</p>
	                            </div>
	                          </div>
	                        </div>
	                        <div class="col-2 text-right align-self-center" v-if="data.scrollPosition > 230">
	                          <div class="rounded-100 inline-grid border-semi-grey d-inline-grid" style="padding:6px" @click="toSearch()"> 
	                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	                              <mask id="mask0_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="16" height="16">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H16.1076V16.1077H1.5V1.5Z" fill="white"/>
	                              </mask>
	                              <g mask="url(#mask0_3948_11251)">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80425 2.625C5.397 2.625 2.625 5.39625 2.625 8.8035C2.625 12.2107 5.397 14.9827 8.80425 14.9827C12.2107 14.9827 14.9827 12.2107 14.9827 8.8035C14.9827 5.39625 12.2107 2.625 8.80425 2.625M8.80425 16.1077C4.77675 16.1077 1.5 12.831 1.5 8.8035C1.5 4.776 4.77675 1.5 8.80425 1.5C12.8318 1.5 16.1077 4.776 16.1077 8.8035C16.1077 12.831 12.8318 16.1077 8.80425 16.1077" fill="#222222"/>
	                              </g>
	                              <mask id="mask1_3948_11251" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="13" width="5" height="5">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9302 13.2803H16.6982V17.0413H12.9302V13.2803Z" fill="white"/>
	                              </mask>
	                              <g mask="url(#mask1_3948_11251)">
	                              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1359 17.0413C15.9926 17.0413 15.8486 16.9866 15.7384 16.8771L13.0954 14.2416C12.8756 14.0218 12.8749 13.6656 13.0946 13.4458C13.3136 13.2246 13.6699 13.2261 13.8904 13.4443L16.5334 16.0806C16.7531 16.3003 16.7539 16.6558 16.5341 16.8756C16.4246 16.9866 16.2799 17.0413 16.1359 17.0413" fill="#222222"/>
	                              </g>
	                            </svg>
	                          </div>
		                      </div>
	                      </div>
	                      <!-- SEARCH -->
	                      <div class="px-2 position-relative" style="top: -20px;" :class="{'position-fixed top--100':data.scrollPosition > 230}">
											    <div class="text-left d-inline-block w-100 mb-0">
											      <input
											        type="text"
											        v-model="data.keyword"
											        @input="searchProduct"
											        class="form-control border box-shadow-1 body-2-1 ls-0-1 search-custom"
											        :placeholder="$t('general.search')"
											        ref="search"
											      />
											    </div>
											  </div>
	                    </div>
											<!-- CATEGORY -->
        							<div 
                        class="container px-4 bg-white" 
                        :class="{
                          'delay':data.scrollPosition > 230, 
                          'pb-1':data.scrollPosition > 230 && getMerchant().category_display === 'HORIZONTAL',
                          'pb-3': getMerchant().category_display === 'DROPDOWN' 
                        }">
                        <div v-if="getMerchant().category_display === 'DROPDOWN'" class="py-2 px-2 d-flex align-items-center justify-content-between border-form radius-6 bg-light-ga"  @click="toggleCategoryPopup(true)">
                          <p class="mb-0 body-3-1">{{ data.category.selected.name }}</p>

                          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_240_7)">
                              <path
                                d="M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9728 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0038 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z"
                                fill="black" fill-opacity="0.85" />
                            </g>
                            <defs>
                              <clipPath id="clip0_240_7">
                                <rect width="13.0479" height="8" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
        								<flickity v-if="getMerchant().category_display === 'HORIZONTAL'" ref="flickity" :options="slider_option.category">
												  <div class="carousel-cell-category text-truncate text-center radius-6 d-table" 
												  	v-for="(category, index) in data.category.list" :key="index">
								          	<p
									            class="body-3 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer bg-light-page radius-6 mr-2"
									            :class="{ 'font-bold delay bg-green text-white border-green' : category.id == data.category.selected.id, 'font-semibold text-unactive' : category.id != data.category.selected.id }"
									            @click="changeCategory(category)"
									          >{{ category.name }}</p>
								          </div>
												</flickity>
											</div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>

	    <!-- Success Copy Data -->
	    <!-- <transition>
	      <div class="w-100 fixed-top" v-show="action_success.show">
	        <b-row class="justify-content-center" no-gutters>
	          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
	            <div
	              class="p-3 border mb-3 radius-0 text-center"
	              style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;"
	            >
	              <p class="mb-0 body-3-1">{{action_success.message}}</p>
	            </div>
	          </b-col>
	        </b-row>
	      </div>
	    </transition> -->

	    <!-- GENERAL INFORMATION -->
	    <template v-if="data.keyword === '' && data.category.selected.id === 'all'">
	    	<!-- SLIDER -->
		    <div class="mb-3 mt-4">
          <block :height="110" />
		      <flickity
		      	v-if="data.general.merchant_images.length != 0"
		        ref="flickity"
		        :options="slider_option.merchant">
		        <div
		          class="carousel-cell w-100"
		          id="carousel-cell1"
		          v-for="slide in data.general.merchant_images"
		          :key="slide.image_url">
		          <div class="w-100" style="height: 250px !important;">
		            <img :src="slide.image_url" class="img-fit" height="150" />
		          </div>
		        </div>
		      </flickity>
		      <div v-else class="w-100" style="height: 250px !important;">
		        <img :src="data.general.image_url" class="img-fit" height="150" />
		      </div>
		    </div>

		    <!-- NAME & OPENING HOUR -->
		    <div class="container mb-4">
		      <div class="px-2">
		        <p class="mb-1 heading-5 text-color-dark">{{ data.general.name }}</p>
		        <div class="d-block mb-1">
		          <p class="body-2-4 mb-0">{{ $t("restaurant.opening-hours") }}: </p>
		          <span class="bullet ml-3"></span>
          		<p
		            class="d-inline-block body-2-2 mb-0 text-black"
		            v-if="data.is_open_today"
		          >
		            {{ $t("merchant.today") }},
		            {{ formatHour(data.general.time_start) }} -
		            {{ formatHour(data.general.time_end) }}
		            <span
		              class="text-green font-semibold"
		            >({{ $t("restaurant.open-now") }})</span>
		          </p>
		          <p
		            class="d-inline-block ml-2 body-2-2 mb-0 text-danger ml-3"
		            v-else
		          >It's closed today</p>
		        </div>
            <p
              class="body-2 pt-1 text-12 mb-0 text-semi-dark cursor-pointer ml-3"
              @click="toggleData('detail_hour')"
            ><u>{{ $t("restaurant.see-all-opening-hours") }}</u></p>
		      </div>
		    </div>

		    <!-- CALL TO ACTION -->
		    <div class="container mb-4" v-if="false">
		      <div class="row text-center border-top-bottom" style="padding: 12px 0px 10px">
		        <div class="col-3">
		          <a :href="'tel: ' + data.general.phone">
		            <div class="text-center d-inline-block align-bottom">
		              <img src="../../assets/img/icon/phone-black.png" width="22" />
		              <p class="body-2 text-12 pt-2 mb-0 text-semi-dark">{{ $t("restaurant.menu.call") }}</p>
		            </div>
		          </a>
		        </div>
		        <div class="col-3">
		          <router-link :to="data.general.code + '/feedback'">
		            <div class="text-center d-inline-block align-bottom">
		              <img src="../../assets/img/icon/review.png" width="22" />
		              <p class="body-2 text-12 pt-2 mb-0 text-semi-dark">{{ $t("restaurant.menu.review") }}</p>
		            </div>
		          </router-link>
		        </div>
		        <div class="col-3">
		          <router-link :to="data.general.code + '/gallery'">
		            <div class="text-center d-inline-block align-bottom">
		              <img src="../../assets/img/icon/ar-camera.png" width="22" />
		              <p class="body-2 text-12 pt-2 mb-0 text-semi-dark">{{ $t("restaurant.menu.gallery") }}</p>
		            </div>
		          </router-link>
		        </div>
		        <div class="col-3">
		          <div class="text-center d-inline-block align-bottom" @click="copyData(data.ww.location.href)">
		            <img src="../../assets/img/icon/share.png" width="22" />
		            <p class="body-2 text-12 pt-2 mb-0 text-semi-dark">{{ $t("restaurant.menu.share") }}</p>
		          </div>
		        </div>
		      </div>
	    		<div class="row border-top-bottom py-2 cursor-pointer position-relative" style="top: -2px;" @click="toggleData('detail_information')">
	    			<div class="col-10 align-self-center">
	    				<p class="mb-0 ml-2 body-3-3 text-green font-weight-bold">{{$t('general.click-to-see-other-information')}}</p>
	    			</div>
	    			<div class="col-2 align-self-center text-right">
	    				<i :class="{'simple-icon-arrow-up' : data.detail_information, 'simple-icon-arrow-down' : !data.detail_information}" class="text-green font-weight-bold text-12 mr-2"></i>
	    			</div>
	    		</div>
		    </div>

		    <!-- FACILITIES & ADDRESS -->
			  <transition name="fade">
			    <div class="container mb-4" v-if="data.detail_information">
			      <div class="px-2 pb-3 border-bottom">
			      	<div class="mb-3">
				      	<p class="heading-5 text-black mb-1 text-18">{{$t('general.facilities')}}</p>
				        <div class="pt-1" v-for="(facility, index) in data.general.facilities" :key="index">
				          <img src="../../assets/img/icon/check.png" width="14" class="mr-2 d-inline-block" />
				          <p class="mb-0 body-2 d-inline-block">{{ facility.name }}</p>
				        </div>
				      </div>

			        <p class="heading-5 text-black mb-1 text-18">{{ $t("restaurant.location-detail") }}</p>
			        <p class="body-2-2-1 mb-0">{{ data.general.address }}</p>
			        <div class>
			          <img src="../../assets/img/icon/copy.png" width="13" class="mr-1" @click="$copyText(data.general.address)" />
			          <p
			            class="mb-2 d-inline-block text-color-orange body-2 text-12 mr-3 cursor-pointer"
			            @click="$copyText(data.general.address)"
			          >{{ $t("restaurant.copy-location") }}</p>
			          <a
			            :href="
			              'https://www.google.com/maps/place/' +
			                data.general.lat +
			                ', ' +
			                data.general.lng
			            "
			            target="_blank"
			          >
			          	<img src="../../assets/img/icon/turn-right.png" width="13" class="mr-1" />
			            <p
			              class="mb-0 d-inline-block text-color-orange body-2 text-12"
			            >{{ $t("restaurant.show-direction") }}</p>
			          </a>
			        </div>
			      </div>
			    </div>
			  </transition>

			  <!-- UNPAID BILL -->
			  <div v-if="getRestaurantAuth().session != ''" class="container mb-4">
			  	<div class="px-2">
			  		<UnpaidBill :is_validate_session="true" />
			  	</div>
        </div>

        <div class="container py-2 px-4 mb-4" v-if="getMerchant().use_booking_table">
	        <div class="w-100 radius-6 border-green position-relative p-3 cursor-pointer" @click="goToBookTable()">
						<div class="d-flex justify-content-between z-index-1026">
							<div style="width: 50px;" class="mr-3 align-self-center">
								<img
	                src="../../assets/img/icon/table-reservation.png"
	                class="w-100"
	              />
							</div>
							<div class="align-self-center w-100">
								<p class="mb-0 sub-heading-1-1">Reserve a table</p>
								<p class="mb-0 body-2-2">{{ $t("restaurant.get-immediate-confirmation") }}</p>
							</div>
							<div class="align-self-center">
								<svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_572_18)">
										<path
											d="M11.4609 10.1719C11.4609 9.87891 11.3438 9.60938 11.1211 9.39844L1.83984 0.304688C1.62891 0.105469 1.37109 0 1.06641 0C0.46875 0 0 0.457031 0 1.06641C0 1.35938 0.117188 1.62891 0.304688 1.82812L8.83594 10.1719L0.304688 18.5156C0.117188 18.7148 0 18.9727 0 19.2773C0 19.8867 0.46875 20.3438 1.06641 20.3438C1.37109 20.3438 1.62891 20.2383 1.83984 20.0273L11.1211 10.9453C11.3438 10.7227 11.4609 10.4648 11.4609 10.1719Z"
											fill="#222222" />
									</g>
									<defs>
										<clipPath id="clip0_572_18">
											<rect width="11.4609" height="20.3555" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</div>
						</div>
						<div class="primary-overlay radius-6 z-index-1025"></div>
					</div>
				</div>
		  </template>

		  <!-- BEST_MENU -->
		  <div class="w-100 mb-4" v-if="data.keyword === '' && data.category.selected.id === 'all' &&data.best_menu.list.length > 0">
		  <!-- <div class="w-100 mb-4" v-if="false"> -->
			  <div class="container mb-3">
			  	<div v-if="is_load.best_menu" class="w-100 text-center">
			  		<loader /> 
			  	</div>
		      <div class="px-2" v-else>
		      	<ErrorMessage v-if="error.best_menu" :message="error.best_menu" />
		      	<template v-else>
			        <p class="heading-6 text-black mb-0 mt-2">{{ data.best_menu.tagline }}</p>
		          <div class="row slim-grid-row">
			          <div class="col-12" v-if="data.best_menu.sub_tagline != ''">
			            <p class="mb-0 d-inline-block body-2-2-1">{{ data.best_menu.sub_tagline }}</p>
			          </div>
			        </div>
		        </template>
		      </div>
		    </div>
		    <div
		      class="pl-3 div-wrappers mx-auto d-inline-block m-width-100"
		      id="best-menu"
		      style="width: 100%"
		    >
		      <div class="">
        		<flickity ref="flickity" :options="slider_option.best_menu">
			      	<div v-for="best_menu in data.best_menu.list">
		      				<menuItemRestaurant :data="best_menu" @detail="toggleDetail" />
			      		<!-- <menuItemCustom :data="best_menu" /> -->
			      	</div>
			      </flickity>
		      </div>
		    </div>
	    </div>
			<menuDetail :data="data.detail.data" :show="data.detail.show" @close="toggleDetail" />

	    <!-- PRODUCT PER CATEGORY -->
      <block v-if="data.keyword != '' || data.category.selected.id != 'all'" :height="175" />
	    <div class="container mb-5" id="product_list">
	      <div class="px-2">
	      	<div v-if="is_load.product" class="w-100 text-center">
			  		<loader /> 
			  	</div>
			  	<template v-else>
			  		<ErrorMessage v-if="error.product" :message="error.product" /> 
				  	<template v-else>
				  		<div class="px-4 pt-3 text-center" v-if="data.product.length == 0">
                <img src="../../assets/img/icon/404.png" width="150" class="text-center">
                <p class="mb-0 mt-3 body-2-2 text-16 font-bold">"{{data.keyword}}"</p>
                <p class="mb-0 body-2-2 font-semibold">{{$t('restaurant.menu-not-found')}}</p>
              </div>
              <template v-else>
					  		<div class="mb-2" v-for="(product_category_group,index_category_group) in data.product" :key="index_category_group">
					  			<!-- GROUP CATEGORY -->
					  			<div :class="{'mb-3':product_category_group.is_show_category}" v-if="data.keyword === '' && data.category.selected.id === 'all'">
						        <p class="heading-6 text-black mb-0">{{ product_category_group.name }}</p>
						        <div v-if="product_category_group.description !=''">
						          <p class="mb-0 body-2-2-1">{{ product_category_group.description }}</p>
						        </div>
					  			</div>

					  			<div class="w-100 mb-5 position-relative" v-for="(product_category,index_category) in product_category_group.category" :key="index_category">
					  				<span class="position-absolute w-100" style="height: 3px;top: -165px;left:0;right:0" :id="product_category.id"></span>
					  				<div v-if="product_category_group.is_show_category || product_category_group.id == null" class="pl-3 mb-3 title-res-left">
						  				<p class="body-1 mb-0 text-green">{{ product_category.name }}</p>
							        <div v-if="product_category.description !=''">
							          <p class="mb-0 body-3-3-1">{{ product_category.description }}</p>
							        </div>
					  				</div>
					        	<menuList :data="product_category.product" :design_type="product_category_group.layout_design" :btn_design_type="product_category_group.button_add_design" />
					        	<div class="w-100" v-if="data.category.selected.id == 'all' && product_category.total_product > 4">
				              <p class="d-table px-2 py-1 mb-0 body-3-3 font-semibold text-green ml-auto border-green rounded-4 cursor-pointer" @click="changeCategory({id:product_category_group.id ,name:product_category_group.name},product_category.id)">Load more</p>
				            </div>
					  			</div>
					  		</div>
              </template>
				  	</template>
			  	</template>
	      </div>
	    </div>

	    <!-- <div class="height-50px" v-if="getRestaurantOrder().cart.length > 0"></div> -->

	    <!-- OPENING DAY -->
	    <transition name="list">
		    <div class="box-warning background-warning" v-if="data.detail_hour">
		      <div class="position-relative" >
		        <div class="row no-gutters justify-content-center">
		          <div class="fixed-top d-block nav-bottom">
		            <div class="custom-container-fluid px-0">
		              <div class="row justify-content-center no-gutters">
		                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		                  <div class="bg-white hide-scroll overflow-scroll">
		                    <div class="w-100">
		                      <div class="mt-5">
		                        <div class="p-3 background-warning">
		                        	<div class="pop-up-warning bg-white text-center box-shadow-1 rounded">
			                        	<div class="pt-3 pb-2 px-1 border-bottom">
			                        		<p class="text-center body-1-1 px-4 text-black mb-0">{{$t('merchant.opening-hours')}}</p>
			                        	</div>
			                        	<div class="container py-3">
			                        		<template v-for="(day_open,index) in data.open_day_list">
					                          <div class="row py-3 border-bottom">
					                            <div class="col-6">
					                              <p class="px-2 body-2-4 mb-0 text-left" :class="!day_open.is_open ? 'text-danger' : ''">{{day_open.title}}</p>
					                            </div>
					                            <div class="col-6 text-right">
					                              <p class="px-2 body-2-4 mb-0" v-if="day_open.is_open">
					                                {{ formatHour(getMerchant().time_start) }} -
					                                {{ formatHour(getMerchant().time_end) }}
					                              </p>
					                              <p class="px-2 body-2-4 mb-0 text-danger" v-else>
					                              	{{$t('general.closed')}}
					                              </p>
					                            </div>
					                          </div>
					                        </template>
				                        </div>
				                        <div class="px-4 py-3 text-center">
		                              <button class="btn body-2-1 text-white btn-secondary" @click="toggleData('detail_hour')">{{$t('general.close')}}</button>
		                          </div>
			                        </div>
		                        </div>
		                      </div>
		                    </div>
		                  </div>
		                </div>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		  </transition>

      <popup-detail 
        direction="bottom" 
        :show="data.category.show"
        :use_max_size="true"
        wrapper_size="mobile"
        title="Category"
        :use_footer="true"
        @close="toggleCategoryPopup">
        <template v-slot:body>
          <div class="py-3 border-t-form w-100">
            <div 
              v-for="(category,categoryIndex) in data.category.list"
              class="w-100 cursor-pointer border-b-form px-4 d-flex justify-content-between align-items-center" 
              :class="categoryIndex > 0 ? 'py-3' : 'pb-3'"
              @click="changeCategory(category, null, true)"
              >
              <p class="mb-0 w-80" :class="data.category.selected.id === category.id ? 'body-2-4 text-green' : 'body-2-1'">{{ category.name }}</p>

              <svg v-if="data.category.selected.id === category.id" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z"
                  class="fill-primary" />
              </svg>
            </div>
          </div>
        </template>
      </popup-detail>
	  </template>

    <FloatingCart />
    <BottomNavbar page="HOME" />
  </div>
</template>
<script>
	import { get } from "@/services/index.js";
	import { mapGetters, mapMutations } from "vuex";
	import { customFormatDateTime, formatCurrency } from "@/utils/index.js";
	import moment from 'moment'
	import Flickity from "vue-flickity";
	import menuItemCustom from '@/components/restaurant-v2/menuItemCustom'
	import menuList from '@/components/restaurant-v2/menuList'
	import FloatingCart from '@/components/restaurant-v2/floatingCart'
	import UnpaidBill from '@/components/restaurant-v2/unpaidBill'
	import menuItemRestaurant from '@/components/restaurant-v2/menuItemRestaurant'
  import menuDetail from '@/components/restaurant-v2/menuDetail'
  import BottomNavbar from "../../components/restaurant-v2/BottomNavbar.vue";

	export default{
		components:{
			Flickity,
			menuItemCustom,
			menuList,
			FloatingCart,
			UnpaidBill,
			menuItemRestaurant,
			menuDetail,
      BottomNavbar
		},
		data(){
			return{
				is_load:{
					general: true,
					category: true,
					best_menu: false,
					product: false
				},
				data:{
					general: {},
					category:{
						list: [],
						selected: {},
            show: false
					},
					best_menu: {
						list: [],
						tagline: '',
						sub_tagline: ''
					},
					product: [],
					scrollPosition: null,
					keyword: '',
					keyword_typing: null,
					is_open_today: false,
					detail_hour: false,
					open_day_list: [],
					detail_information: false,
					ww: window,
					detail:{
						show: false,
						data: {}
					}
				},
				error:{
					general: '',
					category: '',
					best_menu: '',
					product: ''
				},
				slider_option:{
					merchant:{
						initialIndex: 0,
		        autoPlay: 2500,
		        prevNextButtons: false,
		        pageDots: false,
		        adaptiveHeight: true,
		        draggable: true,
		        wrapAround: true,
					},
					promotion:{
						initialIndex: 0,
		        autoPlay: 2500,
		        prevNextButtons: false,
		        pageDots: true,
		        adaptiveHeight: true,
		        cellAlign: "left",
		        draggable: true,
		        wrapAround: true,
					},
					category:{
						initialIndex: 0,
		        autoPlay: false,
		        prevNextButtons: false,
		        pageDots: false,
		        draggable: true,
		        contain: true,
            cellAlign: 'left'
					},
					best_menu:{
						initialIndex: 0,
		        autoPlay: false,
		        prevNextButtons: false,
		        pageDots: false,
		        draggable: true,
		        contain: true,
            cellAlign: 'left',
            groupCells: true
					}
				},
				action_success: {
	        show: false,
	        message: "",
	        timer: 0,
	      },
	      show_detail:false,
	      menu_detail:""
			}
		},
		mounted(){
			window.addEventListener("scroll", this.updateScroll);
			document.getElementById("restaurant").scrollIntoView({
	      behavior: "smooth",
	    });
	    this.loadFirstData()
		},
		computed: {
	    show_success() {
	      return this.action_success.show;
	    },
	  },
		watch:{
			show_success() {
	      if (this.action_success.show) {
	        let looping = setInterval(() => {
	          if (this.action_success.timer > 0) {
	            this.action_success.timer--;
	          } else if (this.action_success.timer == 0) {
	            this.action_success.show = false;
	            this.action_success.message = "";
	            clearInterval(looping);
	          }
	        }, 1000);
	      }
	    },
		},
		methods:{
			// GENERAL
			...mapGetters(["getMerchant","getRestaurantAuth","getRestaurantOrder"]),
			formatHour(time) {
	      return customFormatDateTime(time, "HH:mm:ss", "HH:mm");
	    },
			toggleData(data){
				this.data[data] = !this.data[data]
			},
			updateScroll() {
	      this.data.scrollPosition = window.scrollY;
	    },
	    goToBookTable(){
	    	this.$router.push(`/${this.getMerchant().code}/restaurant/table-booking`)
	    },
	    getListOpenDay(){
	    	this.data.open_day_list = [
	    		{
	    			is_open: this.getMerchant().sale_sunday,
	    			title: this.$t('general.days.sunday')
	    		},
	    		{
	    			is_open: this.getMerchant().sale_monday,
	    			title: this.$t('general.days.monday')
	    		},
	    		{
	    			is_open: this.getMerchant().sale_tuesday,
	    			title: this.$t('general.days.tuesday')
	    		},
	    		{
	    			is_open: this.getMerchant().sale_wednesday,
	    			title: this.$t('general.days.wednesday')
	    		},
	    		{
	    			is_open: this.getMerchant().sale_thursday,
	    			title: this.$t('general.days.thursday')
	    		},
	    		{
	    			is_open: this.getMerchant().sale_friday,
	    			title: this.$t('general.days.friday')
	    		},
	    		{
	    			is_open: this.getMerchant().sale_saturday,
	    			title: this.$t('general.days.saturday')
	    		},
	    	]
	    },
			loadFirstData(){
				this.is_load.general = true
				this.data.general = this.getMerchant()
				this.checkIfTodayIsOpen()

				this.loadCategoryList().then(res_category=>{
					if(res_category === true){
						this.loadGeneralSetting().then(res_general=>{
							if(res_general === true){
								this.loadProductBest().then(res_best_menu=>{
									if(res_best_menu === true){
										this.loadProductList().then(res_product=>{
											if(res_product === true){
												this.getListOpenDay()
												this.is_load.general = false
											}else{
												this.is_load.general = false
												this.error.general = res_product
											}
										})
									}else{
										this.is_load.general = false
										this.error.general = res_best_menu
									}
								})
							}else{
								this.is_load.general = false
								this.error.general = res_general
							}
						})
					}else{
						this.is_load.general = false
						this.error.general = res_category
					}
				})
			},
			searchProduct(){
				if (this.data.keyword_typing != null) {
					clearTimeout(this.data.keyword_typing)
				}
				this.is_load.product = true
				let self = this
				this.data.keyword_typing = setTimeout(() => {
					self.loadProductList()
				}, 1000)
			},
			checkIfTodayIsOpen() {
	      let today = moment().format("d");
	      switch (today) {
	        case "0":
	          if (this.data.general.sale_sunday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        case "1":
	          if (this.data.general.sale_monday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        case "2":
	          if (this.data.general.sale_tuesday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        case "3":
	          if (this.data.general.sale_wednesday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        case "4":
	          if (this.data.general.sale_thursday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        case "5":
	          if (this.data.general.sale_friday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        case "6":
	          if (this.data.general.sale_saturday)
	            this.data.is_open_today = true;
	          else this.data.is_open_today = false;
	          break;

	        default:
	          this.data.is_open_today = false;
	      }
	    },
			xScroll(type, id) {
	      let content = document.querySelector("#" + id);
	      if (type == "left") {
	        content.scrollLeft -= 80;
	      } else {
	        content.scrollLeft += 80;
	      }
	    },
	    changeCategory(data,id_child=null, isPopup=false){
	    	if(data.id != this.data.category.selected.id){
	    		this.data.category.selected = data
	    		if(this.data.category.selected == 'all'){
	    			document.getElementById("product_list").scrollIntoView({
				      behavior: "smooth",
				    });
	    		}
	    		this.loadProductList().then(res=>{
	    			if(res == true && id_child != null){
	    				setTimeout(()=>{
		    				document.getElementById(id_child).scrollIntoView({
						      behavior: "smooth",
						    });
	    				},100)
	    			}
	    		})
	    	}
        if(isPopup) this.toggleCategoryPopup(false)
	    },
	    copyData(data) {
	      var input_temp = document.createElement("input");
	      input_temp.value = data;
	      document.body.appendChild(input_temp);
	      input_temp.select();
	      document.execCommand("copy");
	      document.body.removeChild(input_temp);
	      this.action_success.show = true;
	      this.action_success.message =
	        this.$t('general.successfully-copy-data');
	      this.action_success.timer = 2;
	    },
			toSearch(){
        this.$refs['search'].focus()
        document.getElementById('restaurant').scrollIntoView({
          behavior: 'smooth'
        });
      },
      toggleDetail(data=null){
      	if(data == null){
      		this.data.detail.data = {}
      		this.data.detail.show = false
      	}else{
      		this.data.detail.data = data
      		this.data.detail.show = true
      	}
      },

			// API
			loadCategoryList(){
				return new Promise(done=>{
					this.is_load.category = true
					this.error.category = ''
					this.data.category = {
						list: [],
						selected: {},
            show: false
					}
					get("CORE_RESTO","v2/category-group-option",{
						merchant_id: this.data.general.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							this.data.category.list = res.data
							this.data.category.list.unshift({
								id:'all',
								name: this.$t('general.all-categories')
							})
							this.data.category.selected = this.data.category.list[0]
							done(true)
						}else{
							this.error.category = res.message
							done(res.message)
						}
						this.is_load.category = false
					})
				})
			},
			loadProductBest(){
				return new Promise(done=>{
					this.is_load.best_menu = true
					this.error.best_menu = ''
					this.data.best_menu.list = []
					get("CORE_RESTO","v2/product-best",{
						merchant_id: this.data.general.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							this.data.best_menu.list = res.data.map(bestMenu => {
                bestMenu.openTime = this.$generateOpenCloseProductTime(bestMenu.open_order_time, bestMenu.close_order_time, bestMenu.name)
                return bestMenu;
              })
							done(true)
						}else{
							this.error.best_menu = res.message
							done(res.message)
						}
						this.is_load.best_menu = false
					})
				})
			},
			loadGeneralSetting(){
				return new Promise(done=>{
					this.is_load.best_menu = true
					this.error.best_menu = ''
					this.data.best_menu.tagline = ''
					this.data.best_menu.sub_tagline = ''
					get("CORE_RESTO","v2/general",{
						merchant_id: this.data.general.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							this.data.best_menu.tagline = res.data.best_menu_tagline
							this.data.best_menu.sub_tagline = res.data.best_menu_sub_tagline
							done(true)
						}else{
							this.error.best_menu = res.message
							done(res.message)
						}
						this.is_load.best_menu = false
					})
				})
			},
			loadProductList(){
				return new Promise(done=>{
					this.is_load.product = true
					this.error.product = ''
					this.data.product = []
					let params = {
						merchant_id: this.data.general.id,
						category_group_id: this.data.category.selected.id == 'all' ? '' : this.data.category.selected.id,
						keyword: this.data.keyword
					}

					get("CORE_RESTO","v2/product",params).then(response=>{
						let res = response.data
						if(res.success){
							this.data.product = res.data.map(category => {
                category.category = category.category.map(subCategory=>{
                  subCategory.product = subCategory.product.map(product => {
                    product.openTime = this.$generateOpenCloseProductTime(product.open_order_time, product.close_order_time, product.name)
                    return product;
                  });
                  return subCategory;
                })
                return category;
              })
							done(true)
						}else{
							this.error.product = res.message
							done(res.message)
						}
						this.is_load.product = false
					})
				})
			},

      // Category
      toggleCategoryPopup(show=false){
        this.data.category.show = show
      }
		}
	}
</script>
<style scoped>
	.box-warning{
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .background-warning{
    background-color: rgba(0,0,0,.5)!important;
  }
  .text-black{
    color:#000 !important;
  }
	.search-custom {
	  background-image: url("../../assets/img/icon/search.png");
	  height: 43px;
	  background-color: #fff !important;
	  background-position: 16px 12px;
	  background-size: 15px 15px;
	  -o-object-fit: cover;
	  object-fit: cover;
	  background-repeat: no-repeat;
	  padding: 5px 30px 7px 44px;
	}

	.border-bottom-green-2 {
    border-bottom: 2px solid #79a33a;
  }

  @media screen and (max-width: 600px) {
    .m-width-100 {
      width: 100% !important;
    }

    .mobile-none {
      display: none !important;
    }

  }

  @media screen and (max-width: 655px) {
    .m-width-100 {
      width: 100% !important;
    }

    .mobile-none {
      display: none !important;
    }
  }

	.h-discount {
	  height: 25px;
	}

	ol.flickity-page-dots {
	  text-align: left !important;
	}

	.border-top-bottom {
	  border-top: 2px solid #eee;
	  border-bottom: 2px solid #eee;
	}

	.pop-up {
	  height: 100vh;
	  overflow: scroll;
	}

	.flickity-page-dots .dot {
	  background-color: #79a33a !important;
	}

	.review-img {
	  border-radius: 50%;
	  object-fit: cover;
	}

	.object-fit {
	  object-fit: cover;
	}

	.slide-review {
	  height: auto !important;
	}

	.list-enter,
	.list-leave-to {
	  visibility: hidden;
	  height: 0;
	  margin: 0;
	  padding: 0;
	  opacity: 0;
	}

	.list-enter-active,
	.list-leave-active {
	  transition: all 0.3s;
	}

	.slide-detail {
	  display: inline-block;
	  width: 100px;
	  height: 100px;
	}

	.text-black {
	  color: #000 !important;
	}

	.body-p {
	  font-size: 10px;
	  font-family: Nunito-Regular;
	  color: #9ba1aa;
	  letter-spacing: 0.25px;
	}

	.img-crement {
	  padding: 7px;
	  border-radius: 5px;
	}

	.height-img-promo {
	  height: 155px;
	}

	.height-70 {
	  height: 50px;
	}

	.width-200 {
	  width: 170px !important;
	  margin: 0 8px;
	}

	.w-85 {
	  width: 85%;
	}

	.width-80 {
	  width: 80% !important;
	}

	.div-wrapper {
	  overflow-x: auto;
	  scrollbar-width: none !important;
	  -ms-overflow-style: none !important;
	}

	.div-wrapper::-webkit-scrollbar {
	  display: none !important;
	}

	.div-wrappers {
	  overflow-x: auto;
	  scrollbar-width: none !important;
	  -ms-overflow-style: none !important;
	}

	.div-wrappers::-webkit-scrollbar {
	  display: none !important;
	}

	.div-wrapper-menu {
	  overflow-x: auto;
	  scrollbar-width: none !important;
	  -ms-overflow-style: none !important;
	}

	.div-wrapper-menu::-webkit-scrollbar {
	  display: none !important;
	}

	.div-wrappera {
	  overflow-x: auto;
	  scrollbar-width: none !important;
	  -ms-overflow-style: none !important;
	}

	.div-wrappera::-webkit-scrollbar {
	  display: none !important;
	}

	.search-custom {
	  background-image: url("../../assets/img/icon/search.png");
	  height: 43px;
	  background-color: #fff !important;
	  background-position: 16px 12px;
	  background-size: 15px 15px;
	  -o-object-fit: cover;
	  object-fit: cover;
	  background-repeat: no-repeat;
	  padding: 5px 30px 7px 44px;
	}

	.rounded-bottom-search {
	  border-bottom-left-radius: 10px;
	  border-bottom-right-radius: 10px;
	}

	.add-cart-list {
	  padding: 6px 24px !important;
	}

	.menu-list-desc {
	  height: 65px;
	  overflow: hidden;
	}

	.img-list-2 {
	  height: 92px;
	}

	.text-light-menu {
	  color: #9ba1aa;
	}

	.img-list-3 {
	  height: 190px;
	}

	.add-cart-list-3 {
	  border-radius: 6px;
	  padding: 4px 8px;
	  box-shadow: 4px 4px 10px 0px #dadadac4;
	}

	.add-cart-text-list {
	  padding: 4px 8px;
	  margin-top: 5px;
	  border-radius: 6px;
	  box-shadow: 4px 4px 10px 0px #dadadac4;
	}

	.plus-min-text-list {
	  position: relative;
	  left: 0px;
	  top: 10px;
	  margin-right: -15px;
	}

	.add-note-text-list {
	  position: absolute;
	  margin-top: -27px !important;
	}

	.bg-grey-overlay {
	  filter: grayscale(80%);
	  cursor: not-allowed !important;
	}

	@media screen and (max-width: 600px) {
	  .m-width-100 {
	    width: 100% !important;
	  }

	  .plus-min-set {
	    margin-left: -20px;
	  }

	  .mobile-none {
	    display: none !important;
	  }

	  .top-menu-list {
	    top: 0 !important;
	  }
	}

	@media screen and (max-width: 655px) {
	  .m-width-100 {
	    width: 100% !important;
	  }

	  .ml-0-mobile {
	    margin-left: 0 !important;
	  }

	  .mobile-none {
	    display: none !important;
	  }

	  .img-height-menu {
	    height: 153px !important;
	  }

	  .top-menu-list {
	    top: 0 !important;
	  }

	  .menu-list-desc {
	    height: 42px;
	    overflow: hidden;
	  }

	  .add-cart-list {
	    margin-top: 8px;
	  }

	  .add-note-list {
	    position: relative;
	  }

	  .add-note-list-2 {
	    margin-top: -25px !important;
	    position: absolute;
	  }

	  .img-list-2 {
	    height: 65px !important;
	  }

	  .img-list-3 {
	    height: 129px !important;
	  }

	  .ml-30 {
	    margin-left: 30px !important;
	  }

	  .plus-min-text-list {
	    left: -10px !important;
	    top: 0px !important;
	  }
	}

	@media screen and (max-width: 655px) {
	  .plus-min-list-2 {
	    margin-left: -45px !important;
	  }

	  .plus-min-list-2 input {
	    width: 25px !important;
	  }
	}


</style>


// WEBPACK FOOTER //
// src/pages/restaurant/Home.vue